import React, { DispatchWithoutAction, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fc } from 'i18n';
import Button from 'core/react/general/form/Button';
import { actions } from 'core/redux/api/veta/tep/notifications';
import { InfoTable } from 'components/organisms/tables/info-table';
import { notifyOfficersModalSelector } from 'core/redux/selectors/tep';
import { useNotifyContactsColumns } from 'hooks/tep/leases/useNotifyContactsColumns';

import styles from '../styles.module.css';

interface IContactsProps {
  onBack: DispatchWithoutAction;
}

export const Contacts: FC<IContactsProps> = ({ onBack }) => {
  const dispatch = useDispatch();

  const { error, officers, leases, selectedOfficersIds } = useSelector(notifyOfficersModalSelector);

  const columns = useNotifyContactsColumns();

  const notifyOfficers = () => {
    if (!selectedOfficersIds.length) {
      return dispatch(actions.notifyOfficers.fail({ errorMessage: 'no enforcement officers’ contacts selected' }));
    }

    const payload = leases.map(({ id }) => ({ entryPassId: id, officerIds: selectedOfficersIds }));

    dispatch(actions.notifyOfficers.request({ payload }));
  };

  return (
    <div>
      <InfoTable selectedIds={selectedOfficersIds} columns={columns} data={officers} />
      <div className={styles.totalCount}>{`Total No. Of Entries : ${officers.length}`}</div>
      <div className={styles.footer}>
        {!!error && <div className={styles.error}>{fc(error)}</div>}
        <Button onClick={onBack} className={`${styles.button}`}>
          <span>{fc('back')}</span>
        </Button>
        <Button onClick={notifyOfficers} className={`${styles.button} ${styles.submit} active`}>
          <span>{fc('notify')}</span>
        </Button>
      </div>
    </div>
  );
};
